// src/utils/s3.ts
export const s3Url = (key: string) =>
  `https://funizzle-files.s3.us-east-1.amazonaws.com/${key}`;



//   // src/utils/s3.ts
// export const s3Url = (key: string) =>
//   `${process.env.REACT_APP_SERVER_BASE_URL}/s3/streaming?key=${encodeURIComponent(
//     key,
//   )}`;